module.exports = __webpack_public_path__ + "img/1501706283.5b24d05e.jpg";